/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { PostTraduzioniTranslateBody, WsProblema } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Traduce il file in input con IA, in formato csv.
 * @summary Traduzioni con IA
 */
export const postTraduzioniTranslate = (
  postTraduzioniTranslateBody: PostTraduzioniTranslateBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postTraduzioniTranslateBody.file);

  return apiClientRequest<string>(
    {
      url: `/framework-cfg-domande/traduzioni/translate`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostTraduzioniTranslateMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTraduzioniTranslate>>,
    TError,
    { data: PostTraduzioniTranslateBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTraduzioniTranslate>>,
  TError,
  { data: PostTraduzioniTranslateBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTraduzioniTranslate>>,
    { data: PostTraduzioniTranslateBody }
  > = props => {
    const { data } = props ?? {};

    return postTraduzioniTranslate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTraduzioniTranslateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTraduzioniTranslate>>
>;
export type PostTraduzioniTranslateMutationBody = PostTraduzioniTranslateBody;
export type PostTraduzioniTranslateMutationError = ErrorType<WsProblema>;

/**
 * @summary Traduzioni con IA
 */
export const usePostTraduzioniTranslate = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTraduzioniTranslate>>,
    TError,
    { data: PostTraduzioniTranslateBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTraduzioniTranslateMutationOptions(options);

  return useMutation(mutationOptions);
};
